import { createAction, props } from '@ngrx/store';

export const updateMainColors = createAction(
  '[White Labeling] Update main colors',
  props<{
    payload: { primary: string; secondary: string };
  }>()
);
